import React, { useEffect } from "react";
import {
  Box,
  Typography,
  Switch,
  FormControlLabel,
  Paper,
  CircularProgress,
} from "@mui/material";
import { DataGrid } from "@mui/x-data-grid";
import { useDispatch, useSelector } from "react-redux";
import {
  fetchTableOne,
  fetchTableTwo,
  fetchTableThree,
  toggleLiverun,
  setSelectedDate,
} from "../reducers/activityFrameSlice";

const TABLE_ONE_COLUMNS = [
  { field: "date", headerName: "Date", width: 240 },
  { field: "filed", headerName: "Filed", width: 120 },
  { field: "filed_abnormal", headerName: "Filed Abnormal", width: 120 },
  { field: "not_filed_range", headerName: "Not Filed (Range)", width: 120 },
  { field: "not_filed_setup", headerName: "Not Filed (Setup)", width: 120 },
  { field: "not_filed_already", headerName: "Not Filed (Already)", width: 120 },
];

const TABLE_TWO_COLUMNS = [
  { field: "category", headerName: "Category", width: 640 },
  { field: "filed", headerName: "Filed", width: 120 },
  { field: "filed_abnormal", headerName: "Filed Abnormal", width: 120 },
  { field: "not_filed_range", headerName: "Not Filed (Range)", width: 120 },
  { field: "not_filed_setup", headerName: "Not Filed (Setup)", width: 120 },
  { field: "not_filed_already", headerName: "Not Filed (Already)", width: 120 },
];

const TABLE_THREE_COLUMNS = [
  { field: "emis_id", headerName: "EMIS ID", width: 120 },
  { field: "category", headerName: "Category", width: 280 },
  { field: "status", headerName: "Status", width: 80 },
  { field: "endtime", headerName: "End Time", width: 120 },
  { field: "notes", headerName: "Notes", width: 600 },
];

const PathologyFrame = () => {
  const dispatch = useDispatch();

  const {
    liverun,
    tableOne,
    tableTwo,
    tableThree,
    selectedDate,
    loadingOne,
    loadingTwo,
    loadingThree,
  } = useSelector((state) => state.activityFrame);

  const license_key = useSelector(
    (state) => state.authen.loggedInUser?.license_key,
  );

  useEffect(() => {
    if (license_key) {
      dispatch(fetchTableOne({ liverun, license_key }));
    }
  }, [liverun, license_key, dispatch]);

  const handleRowSelect = (params) => {
    const dateTitle = params.row?.date;
    dispatch(setSelectedDate(dateTitle));
    dispatch(fetchTableTwo({ date: dateTitle, liverun, license_key }));
    dispatch(fetchTableThree({ date: dateTitle, liverun, license_key }));
  };

  return (
    <Box sx={{ mt: 1, pt: 0, pb: 0, px: 2 }}>
      <Paper elevation={2} sx={{ mt: 1, pt: 0, pb: 0, px: 2 }}>
        <Box sx={{ display: "flex", alignItems: "center", mb: 1 }}>
          <Typography variant="h6" sx={{ flexGrow: 1 }}>
            Activity - {liverun ? "Live Data" : "Dry Run Data"}
          </Typography>
          <FormControlLabel
            control={
              <Switch
                checked={liverun}
                onChange={() => dispatch(toggleLiverun())}
              />
            }
            label="Live / Dry Run"
          />
        </Box>

        <Typography variant="subtitle1" gutterBottom>
          Date-wise Filings
        </Typography>
        {loadingOne ? (
          <CircularProgress />
        ) : (
          <DataGrid
            pageSizeOptions={[10]}
            rowHeight={25}
            rows={tableOne}
            columns={TABLE_ONE_COLUMNS}
            initialState={{
              pagination: {
                paginationModel: {
                  pageSize: 10,
                },
              },
            }}
            onRowClick={handleRowSelect}
            getRowClassName={(params) =>
              params.indexRelativeToCurrentPage % 2 === 0 ? "even" : "odd"
            }
          />
        )}
      </Paper>

      {selectedDate && (
        <>
          <Paper elevation={2} sx={{ mt: 1, pt: 0, pb: 0, px: 2 }}>
            <Typography variant="subtitle1" gutterBottom>
              Category Data for {selectedDate}
            </Typography>
            {loadingTwo ? (
              <CircularProgress />
            ) : (
              <DataGrid
                rowHeight={25}
                rows={tableTwo}
                columns={TABLE_TWO_COLUMNS}
                initialState={{
                  pagination: {
                    paginationModel: {
                      pageSize: 10,
                    },
                  },
                }}
                getRowClassName={(params) =>
                  params.indexRelativeToCurrentPage % 2 === 0 ? "even" : "odd"
                }
              />
            )}
          </Paper>

          <Paper elevation={2} sx={{ mt: 1, pt: 0, pb: 0, px: 2 }}>
            <Typography variant="subtitle1" gutterBottom>
              Day Data for {selectedDate}
            </Typography>
            {loadingThree ? (
              <CircularProgress />
            ) : (
              <DataGrid
                rowHeight={25}
                rows={tableThree}
                columns={TABLE_THREE_COLUMNS}
                pageSize={5}
                initialState={{
                  pagination: {
                    paginationModel: {
                      pageSize: 10,
                    },
                  },
                }}
                getRowClassName={(params) =>
                  params.indexRelativeToCurrentPage % 2 === 0 ? "even" : "odd"
                }
              />
            )}
          </Paper>
        </>
      )}
    </Box>
  );
};
export default PathologyFrame;
